import { Fragment } from 'react';

import { BreadcrumbItemType } from '@/types/file-explorer-types';

import { cn } from '@/lib/utils';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from '@/components/ui/breadcrumb';

import { AGREEMENT_ROOT_NAME } from '@/constants/global-constants';
import { ExplorerItemType } from '@/constants/table-columns-config';

interface BreadCrumbsComponentProps {
  breadcrumbs: BreadcrumbItemType[];
  isSmall?: boolean;
  searchTerm?: string;
  setCurrentUUID: (uuid: string) => void;
  setCurrentEntityType: (type: ExplorerItemType) => void;
  handleNavigate: (uuid: string, type: ExplorerItemType) => void;
  totalDocuments: number;
  isRootLevel: boolean;
}

const BreadCrumbsComponent = ({
  breadcrumbs,
  isSmall,
  searchTerm,
  setCurrentUUID,
  setCurrentEntityType,
  handleNavigate,
  totalDocuments,
  isRootLevel,
}: BreadCrumbsComponentProps) => {
  if (searchTerm) {
    return (
      <div className="flex items-center pl-[20px] pt-6 sm:pl-9 sm:pt-[24px]">
        <h1 className="text-2xl font-medium">
          Результати пошуку: {searchTerm}
        </h1>
      </div>
    );
  }

  if (breadcrumbs.length === 0 || isRootLevel) {
    return (
      <div className="flex items-center pl-[20px] pt-6 sm:pl-9 sm:pt-[24px]">
        <h1 className="text-2xl font-medium">
          {`${AGREEMENT_ROOT_NAME}${totalDocuments ? ` (${totalDocuments})` : ''}`}
        </h1>
      </div>
    );
  }

  return (
    <Breadcrumb
      className={cn(
        'flex min-h-[56px] flex-shrink-0 pl-9 pr-5 pt-6',
        isSmall ? 'border-b border-b-separator py-2' : '',
      )}
    >
      <BreadcrumbList className={cn(isSmall ? '' : 'max-w-[calc(100%-170px)]')}>
        {breadcrumbs.map((item, index) => (
          <Fragment key={item.id}>
            {index > 0 && (
              <span
                className={`text-primary ${
                  isSmall ? 'text-sm' : 'text-2xl font-medium'
                }`}
              >
                &gt;
              </span>
            )}
            <BreadcrumbItem>
              <BreadcrumbLink
                onClick={() => {
                  setCurrentUUID(item.id);
                  setCurrentEntityType(item.type);
                  handleNavigate(item.id, item.type);
                }}
                className={`text-primary ${
                  isSmall ? 'text-sm' : 'text-2xl font-medium'
                }`}
              >
                {item.name}
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadCrumbsComponent;
